import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=7843a018&scoped=true&"
import script from "./PortalLayout.vue?vue&type=script&lang=js&"
export * from "./PortalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=7843a018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843a018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7843a018')) {
      api.createRecord('7843a018', component.options)
    } else {
      api.reload('7843a018', component.options)
    }
    module.hot.accept("./PortalLayout.vue?vue&type=template&id=7843a018&scoped=true&", function () {
      api.rerender('7843a018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portalContent/portalInformation/components/PortalLayout.vue"
export default component.exports